var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalLockSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 3,
    fill: "#D7EED5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31875 15H12.9313C13.2436 15 13.5 14.7348 13.5 14.408V8.73214C13.5 8.40536 13.2461 8.14286 12.9313 8.14286H12.3828V7.31518C12.3828 6.20357 11.9715 4.96875 11.3012 4.22411C10.6334 3.47946 9.67617 3 8.62754 3C8.625 3 8.625 3 8.625 3H8.62246C7.57383 3 6.6166 3.47946 5.94883 4.22143C5.27852 4.96607 4.86719 6.20089 4.86719 7.3125V8.14286H4.38477H4.31875C4.00391 8.14286 3.75 8.40804 3.75 8.73214V14.408C3.75 14.7348 4.00391 15 4.31875 15ZM6.21289 7.31518C6.21289 6.58393 6.46426 5.67857 6.92637 5.16429V5.15625C7.37324 4.65804 7.99023 4.36607 8.62246 4.36607H8.625H8.62754C9.25977 4.36607 9.87676 4.65804 10.3236 5.15625V5.16161L10.3211 5.16429C10.7857 5.67857 11.0346 6.58393 11.0346 7.31518V8.14286H10.5902H6.65469H6.21289V7.31518Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalLockSecondary);
export default __webpack_public_path__ + "static/media/modal-lock-secondary.ec9ae5d219a56457f2eca7a4bcf63949.svg";
export { ForwardRef as ReactComponent };